import { createServerFn } from "@tanstack/react-start"
import { getChats as getChatsService } from "@apps/gwservice/chats"
import { withAuth } from "~/features/auth/server/auth"
import { Result } from "@praha/byethrow"

export const getChats = createServerFn({
  method: "GET",
})
  .inputValidator((data: { query?: string }) => data)
  .handler(({ data }) => Result.try({
    try: () => withAuth(getChatsService)(data.query),
    catch: () => "unexpected server error",
  }))
